export type CertfiqueNavItem = { label: string; href: string; external?: boolean };

export const CERTFIQUE_MENU_SOLUCOES: CertfiqueNavItem[] = [
  { label: "e-CNPJ A1", href: "#produtos" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Marketplaces", href: "#marketplaces" },
  { label: "Para empresas", href: "#solucoes" }
];

export const CERTFIQUE_MENU_CONTEUDO: CertfiqueNavItem[] = [
  { label: "Como funciona", href: "#como-funciona" },
  { label: "Avaliações Google", href: "#avaliacoes" },
  { label: "Dúvidas frequentes", href: "#faq" }
];

export const CERTFIQUE_MENU_AJUDA: CertfiqueNavItem[] = [
  { label: "FAQ e-CNPJ A1", href: "#faq" },
  { label: "Contato", href: "#contato" },
  { label: "Fale no WhatsApp", href: "#contato" },
  {
    label: "Reclame AQUI",
    href: "https://www.reclameaqui.com.br/empresa/sp-certificado-digital/",
    external: true
  }
];
